import { AutogenLayoutStateAddAdditionalTaxes } from "./autogen/AutogenLayoutStateAddAdditionalTaxes";
import { FieldUpdateEvent } from "@mcleod/core";
import { DataSourceMode, DataSourceModeChangeEvent, LookupModelSearchEvent } from "@mcleod/components";

export class StateAddAdditionalTaxes extends AutogenLayoutStateAddAdditionalTaxes {
    onLoad(): void | Promise<void> {
        this.mainDataSource.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            if (event.newMode === DataSourceMode.UPDATE || event.newMode === DataSourceMode.ADD) {
                this.setJobClassCodeIdVisible();
                this.setRequiredTaxTables();
                this.activeRow.addAfterFieldUpdateListener((event: FieldUpdateEvent) => {
                    if (event.fieldName === "tax_type") {
                        this.setJobClassCodeIdVisible();
                    }
                    if (event.fieldName === "employee_addtl_table" || event.fieldName === "employer_addtl_table") {
                        this.setRequiredTaxTables();
                    }
                });
            }
        });
        this.textboxDeductCodeId.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter.code_type = "D";
        });
    }

    setJobClassCodeIdVisible(): void {
        const workersCompValue = "W";
        this.textboxJobClassCodeId.visible = this.activeRow.get("tax_type") === workersCompValue;
        this.textboxJobClassCodeId.required = this.textboxJobClassCodeId.visible;
    }

    setRequiredTaxTables() {
        this.textboxEmployerAddtlTable.required = this.activeRow.isNull("employee_addtl_table");
        this.textboxEmployeeAddtlTable.required = this.activeRow.isNull("employer_addtl_table");
        this.textboxEmployerAddtlTable.validateSimple(true, false);
        this.textboxEmployeeAddtlTable.validateSimple(true, false);
    }
}
